<template>
  <div class="overdue-deital">
    <!-- eslint-disable-next-line vue/no-mutating-props -->
    <el-dialog :visible.sync="dialogVisible"
      :title="title"
      :width="width"
      :before-close="handleClose"
    >
    <div class="collect-box">
      <OperationSummary :summary="summary"></OperationSummary>
      <export
        :exportTemplate="exportTemplate"
        filename="逾期汇总详情.xlsx"
        :params="exportParams"
        v-if="judgePermission('overdueDetailExport')"
      ></export>
    </div>

      <!-- 列表 -->
      <QS-common-table
        :data="tableData"
        :columns="columns"
        :pagination="paginationData"
        :loading="tableLoading"
        @change="paginationChange"
      >
      </QS-common-table>
    </el-dialog>
  </div>
</template>

<script>
import config from '../../config/summary/detailDialog'
import OperationSummary from '@/components/OperationSummary'
import { detailOverDue, receivableSummary } from '@/api/domain/orders'

export default {
  components: {
    OperationSummary,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    title: {
      type: String,
      default: '明细数据',
    },
    width: {
      type: String,
      default: '824px',
    },
  },
  data() {
    const { columns, summaryMap } = config.call(this, this.data.customerType)

    return {
      exportParams: {},
      tableData: [],
      tableLoading: false,
      columns,
      paginationData: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
      summaryMap,
      summary: [],
      exportTemplate: 'OverDueDetail',
    }
  },
  created() {
    this.detailOverDue()
    this.receivableSummary()
  },
  methods: {
    // 切换页码
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.detailOverDue()
    },
    handleClose() {
      this.$emit('close')
    },
    // 明细列表
    async detailOverDue() {
      const params = {
        customerId: this.data.customerId,
        customerType: this.data.customerType,
        startDate: this.data.startDate || '',
        endDate: this.data.endDate || '',
        pageSize: this.paginationData.pageSize,
        pageNum: this.paginationData.pageNum,
        finishState: this.data.finishState, // 还款状态
        carModelId: this.data.carModelId, // 车型
        orderStateList: this.data.orderStateList, // 租赁状态
        brandId: this.data.brandId,
        seriesId: this.data.seriesId,
        modelId: this.data.modelId,
      }
      this.tableLoading = true
      const { code, data } = await detailOverDue(params)

      this.tableLoading = false

      this.exportParams = Object.assign({}, params)

      if (code === 1) {
        this.tableData = (data && data.items) || []
        this.paginationData.total = data.totalNum
      }
    },
    // 统计
    async receivableSummary() {
      this.summary = []
      const { code, data } = await receivableSummary({
        customerId: this.data.customerId,
        customerType: this.data.customerType,
        startDate: this.data.startDate || '',
        endDate: this.data.endDate || '',
        finishState: this.data.finishState, // 还款状态
        carModelId: this.data.carModelId, // 车型
        orderStateList: this.data.orderStateList, // 租赁状态
        brandId: this.data.brandId,
        seriesId: this.data.seriesId,
        modelId: this.data.modelId,
      })
      if (code === 1) {
        Reflect.ownKeys(data || {}).forEach((key) => {
          this.summary.push({
            subTitle: this.summaryMap[key],
            numbers: data[key] || '0',
            unit: '单',
          })
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
[class^="overdue-"] {
  ::v-deep .operation-summary .content-box .content-perIt .need-show-text{
    align-items: baseline;
    padding-top: 4px;
    .enlarge-content {
      padding-right: 2px;
    }
  }
  .collect-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
  }
}
</style>
